import { Link, useNavigate } from 'react-router-dom';

import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import { SxProps, Theme } from '@mui/material/styles';
import SvgIcon from '@mui/material/SvgIcon';
import Typography from '@mui/material/Typography';

import { PageContextProps, useApp } from '../../contextProviders/AppProvider';
import { useAuth } from '../../contextProviders/AuthProvider';
import { useData } from '../../contextProviders/DataProvider';
import Person from '../../types/Person';

interface GratiNavListProps {
  person?: Person;
  sx?: SxProps<Theme>;
  isDebug?: boolean;
  resetReactRoutes?: boolean;
}

export default function GratiNavList(props: GratiNavListProps) {
  const { person, sx, isDebug = false, resetReactRoutes = false } = props;
  const { pageContexts } = useApp();
  const { isGod } = useAuth();
  const { userState } = useData();
  const navigate = useNavigate();

  const showItem = (page: PageContextProps, person?: Person | null) => {
    if (!person) {
      return null;
    }

    const isLoggedIn = (isDebug && isGod) || userState.status === 'ready';

    if (page.showLogin && isLoggedIn) {
      return true;
    }
    if (page.showLogout && !isLoggedIn && !isDebug) {
      return true;
    }

    return false;
  };

  return (
    <List sx={{ ...(Array.isArray(sx) ? sx : [sx]), width: '100%', pt: '0px', display: 'block' }}>
      {pageContexts.map((page) =>
        showItem(page, person ?? userState.userProfile) ? (
          <ListItem key={page.name} alignItems="center" disablePadding sx={{ width: '100%' }}>
            {resetReactRoutes ? (
              <IconButton
                key={page.name}
                onClick={() => navigate(page.to, { replace: true, state: { fromNavRail: true } })}
              >
                {page.icon ? <SvgIcon component={page.icon} /> : null}
                <Typography variant="iconbutton" sx={{ textAlign: 'center' }}>
                  {page.name}
                </Typography>
              </IconButton>
            ) : (
              <IconButton key={page.name} component={Link} to={page.to}>
                {page.icon ? <SvgIcon component={page.icon} /> : null}
                <Typography variant="iconbutton" sx={{ textAlign: 'center' }}>
                  {page.name}
                </Typography>
              </IconButton>
            )}
          </ListItem>
        ) : null
      )}
    </List>
  );
}
